import axios from ".";

export const getDeptartmentOwners = () => {
  return axios({
    method: "GET",
    url: `/role-management/department-owners/1`,
  });
};

export const getUsersByRoles = (roleId: number) => {
  return axios({
    method: "GET",
    url: `/role-management/employees/1/role/${roleId}`,
  });
};

export const assignDepartmentOwner = (params: {
  employeeId: number;
  departmentId: number;
  applicationId: number;
  roleId: number;
}) => {
  return axios({
    method: "POST",
    url: `/role-management/department/assign-owner`,
    data: params,
  });
};

export const updateRoles = (params: {
  employeeId: number;
  roleName: string;
  departmentId: number | null;
  applicationId: number;
}) => {
  return axios({
    method: "POST",
    url: `/role-management/employee/update-role`,
    data: params,
  });
};

export const assignEltRoles = (params: {
  employeeId: number[];
  roleId: number;
}) => {
  return axios({
    method: "POST",
    url: `/role-management/employee/assign-role`,
    data: params,
  });
};
